import { lazy } from 'react';
import { useState, useEffect } from 'react';

const OverviewPage = lazy(() => import('@pages/kidney/OverviewPage.jsx'));
const TherapyPage = lazy(() => import('@pages/kidney/TherapyPage.jsx'));
const FacilitiesPage = lazy(() => import('@pages/kidney/FacilitiesPage.jsx'));
const WelfarePage = lazy(() => import('@pages/kidney/WelfarePage.jsx'));

const KidneyWrapper = ({ Component }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <Component isMobile={isMobile} />;
};

const kidneyRouter = () => {
  return [
    {
      path: 'overview',
      element: <KidneyWrapper Component={OverviewPage} />,
    },
    {
      path: 'therapy',
      element: <KidneyWrapper Component={TherapyPage} />,
    },
    {
      path: 'facilities',
      element: <KidneyWrapper Component={FacilitiesPage} />,
    },
    {
      path: 'welfare',
      element: <KidneyWrapper Component={WelfarePage} />,
    },
  ];
};

export default kidneyRouter;
